export const EUROPE = "Europe";
export const ASIA = "Asia";
export const AFRICA = "Africa";
export const NORTH_AMERICA = "North America";
export const OCEANIA = "Oceania";
export const SOUTH_AMERICA = "South America";
